export default "__VITE_ASSET__dOU9s6SS__"